import {FC, useCallback, useState} from 'react';
import style from './style.module.scss';
import {Typography} from 'components/Typography';
import {ICategory} from 'modules/categories/types';
import classNames from 'classnames';
import Link from 'components/CustomRoutingLink';

interface IProps {
    list: ICategory[];
}

const MAX_CATEGORIES = 6;

export const CatalogMenuCategoriesList: FC<IProps> = ({list}) => {
    const [isShowMore, setShowMore] = useState<boolean>(false);

    const renderCategoriesListItem = ({code, categoryName, src, href}: ICategory, index: number) => {
        return (
            <li className={style.categoriesListItemContainer} key={`${href}${src}`}>
                <Link className={style.categoriesListItem} href={href || ''} key={`link-${index}`}>
                    {src && <img alt={code} className={style.categoriesListImg} src={src} />}
                    <Typography element={'div'} variant={'label-16-r'}>
                        {categoryName}
                    </Typography>
                </Link>
            </li>
        );
    };

    const handleClickMore = useCallback(() => {
        setShowMore(true);
    }, []);

    return (
        <ul className={style.categoriesList}>
            {list.slice(0, MAX_CATEGORIES).map((item, index: number) => renderCategoriesListItem(item, index))}
            {Boolean(list.length > MAX_CATEGORIES) && !isShowMore && (
                <li>
                    <button
                        className={classNames(style.categoriesListItemContainer, style.moreButton)}
                        onClick={handleClickMore}
                    >
                        <Typography color={'gray60'} variant={'p'}>
                            Еще
                        </Typography>
                    </button>
                </li>
            )}
            {isShowMore &&
                list
                    .slice(MAX_CATEGORIES, list.length)
                    .map((item, index: number) => renderCategoriesListItem(item, index))}
        </ul>
    );
};
